
import { User } from 'apprise-core/user'
import { useInterceptor } from 'apprise-frontend-core/client/interceptor'
import { useEnv } from 'apprise-frontend-core/env'
import { LanguageObserver } from 'apprise-frontend-core/intl/langobserver'
import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { EventSubscriber } from 'apprise-frontend-events/subscriptions'
import { useOracle } from 'apprise-frontend-iam/authz/oracle'
import { LoginConfig, LoginConfigProvider, LoginProvider } from 'apprise-frontend-iam/login/context'
import { useDevAuthInterceptor, useLoginErrorInterceptor } from 'apprise-frontend-iam/login/interceptors'
import { useLogged } from 'apprise-frontend-iam/login/logged'
import { UserLabel } from 'apprise-frontend-iam/user/label'
import { usePreferences } from 'apprise-frontend-iam/user/preferences'
import { usePreferencesPlugin } from 'apprise-ui/preferences'
import { useUsernameResolverPlugin } from 'apprise-ui/usernameresolver'
import { PropsWithChildren } from 'react'
import { userLogoutTopic } from '../user/constants'
import { useUserLogoutListener } from '../user/events'
import { LoggedUserLoader } from './loader'






export type LoginState = {

    logged: User
    allowGuest: boolean
}

export type LoginProps = React.PropsWithChildren<Partial<LoginConfig>>

// initialises the model and loads users, and mounts the state if required.
export const Login = (props: LoginProps) => {

    const { children, ...config } = props

    return <LoginConfigProvider {...config}>
        <LoginProvider >
            <CallInterceptors>
                <LoggedUserLoader>
                    <LanguageChangeObserver />
                    <LogoutObserver />
                    <Initialiser>
                        {children}
                    </Initialiser>
                </LoggedUserLoader>
            </CallInterceptors>
        </LoginProvider>
    </LoginConfigProvider>


}


export const CallInterceptors = (props: PropsWithChildren) => {

    const { children } = props

    const interceptors = useInterceptor()

    const env = useEnv()

    const devAuthInterceptor = useDevAuthInterceptor()
    const errorInterceptor = useLoginErrorInterceptor()

    const { content } = useRenderGuard({

        render: children,
        orRun: () => {

            if (env.name == 'development')
                interceptors.addOnRequest(devAuthInterceptor)


            interceptors.addOnError(errorInterceptor)
        }
    })

    return content


}


export const LogoutObserver = () => {

    const logoutListener = useUserLogoutListener()

    return <EventSubscriber name={userLogoutTopic} subscriptions={[logoutListener]} />



}



const LanguageChangeObserver = () => {

    const current = useLogged().details.preferences.language

    console.log({current})

    return <LanguageObserver language={current} />
}


const Initialiser = (props: LoginProps) => {

    const { children } = props

    const logged = useOracle()

    const { get, saveWith } = usePreferences()

    const preferencesPlugin = usePreferencesPlugin()
    const usernameResolverPlugin = useUsernameResolverPlugin()


    const activate = async () => {

        // adapts user preference for access from UI components.
        preferencesPlugin.register({ isEnabled: () => !logged.isGuest(), get, set: saveWith })

        usernameResolverPlugin.register({ resolve: username => <UserLabel noReadonly bare user={username} /> })


    }




    const { content } = useRenderGuard({

        render: children,
        orRun: activate
    })

    return content


}

